import Text from '@eversports/react-components/primitives/Text'
import { assertNever } from '@eversports/utility-types'
import React from 'react'

import { Localized } from '../../../localization/react'

interface Court {
  type: 'court'
  venueName: string
  courtName: string
  sport: string
}

interface Event {
  type: 'event'
  venueName: string
  activityName: string
  sport: string
}

type Props = Court | Event

const BookingDetailsName: React.FC<React.PropsWithChildren<Props>> = (props) => {
  switch (props.type) {
    case 'court':
      return (
        <div>
          <Text fontWeight="bold">{props.venueName}</Text>
          <Text fontWeight="bold">
            <Localized id="court-booking-details-name" params={{ sport: props.sport, courtName: props.courtName }} />
          </Text>
        </div>
      )
    case 'event':
      return (
        <div>
          <Text fontWeight="bold">{props.activityName}</Text>
          <Text size="small">{props.venueName}</Text>
        </div>
      )
    default:
      return assertNever(props)
  }
}

export default BookingDetailsName
